import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';
import PageHeader from '@/components/PageHeader';
import Footer from '@/components/footer';

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const location = useLocation();
  const isAuthenticated = useIsAuthenticated();
  const isSubscribePage = location.pathname.includes('/subscribe');
  const isArticlePage = location.pathname.includes('/article');
  const topPaddingClasses = !isAuthenticated
    ? 'pt-[64px] desktopNav:pt-[72px]'
    : isSubscribePage || isArticlePage
      ? 'pt-[64px] desktopNav:pt-[112px]'
      : 'pt-[106px] desktopNav:pt-[154px]';

  return (
    <div className='flex flex-col min-h-screen mx-auto'>
      <PageHeader />
      <main className='grow'>
        <div className={`mx-auto ${topPaddingClasses} print:pt-0`}>{children}</div>
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
